import { EntityIcon } from '@components/core-ui/EntityIcon/';
import DownIcon from '@components/core-ui/Table/SortingDirection/down.svg';
import UpIcon from '@components/core-ui/Table/SortingDirection/up.svg';
import { routes } from '@routes';
import { MeResponseDtoOrganization } from 'app/API';
import { useNavigate } from 'react-router';

export type TProps = {
  organization: MeResponseDtoOrganization;
  setOrgListOpen: (value: boolean) => void;
  orgListOpen: boolean;
};

export const CurrentOrganizationRow = ({ setOrgListOpen, orgListOpen, organization }: TProps) => {
  const navigate = useNavigate();

  const nameSection = orgListOpen ? (
    <span className="w-full whitespace-nowrap overflow-hidden text-ellipsis max-w-[150px]">{organization.name}</span>
  ) : (
    <div>
      <span
        onClick={() => setOrgListOpen(!orgListOpen)}
        className="text-xs font-semibold block max-w-[150px] overflow-hidden text-ellipsis"
      >
        {organization.name}
      </span>
      <button
        type="button"
        className="flex items-center hover:text-[var(--color-title)]"
        onClick={() => navigate(routes.organizationDetails.make(organization.slug))}
      >
        <span className="inline-block h-4 leading-5 mr-1 text-xs">Details</span>
      </button>
    </div>
  );

  return (
    <div
      onClick={() => orgListOpen && setOrgListOpen(!orgListOpen)}
      className="text-foreground-muted rounded-[5px] flex items-center px-2.5 py-[5px] m-0 font-medium text-xs leading-[130%] relative cursor-pointer min-h-12"
    >
      <div onClick={() => setOrgListOpen(!orgListOpen)} className="w-auto flex-shrink-0">
        <EntityIcon name={organization.name} src={organization.image ?? undefined} className="mx-[6px] ml-0.5" />
      </div>
      {nameSection}

      <button
        type="button"
        aria-label="Switch organization"
        aria-expanded={orgListOpen}
        onClick={() => setOrgListOpen(!orgListOpen)}
        className="w-5 max-xl:min-w-11 ml-2.5 absolute right-2.5 top-0 h-full flex justify-center items-center"
      >
        {orgListOpen ? <UpIcon className="w-[8px] h-[8px]" /> : <DownIcon className="w-[8px] h-[8px]" />}
      </button>
    </div>
  );
};
